import {
    getColumbaAccessoryByRepairEquipmentId,
    getSwanAccessoryByRepairEquipmentId
} from "@/request/view/repair";
import {
    standardConfigOptions,
    optionalOptions,
} from "@/views/repairprogress/serve/accessory";

export const getshowAccessoryByReq = (type, id) => {
    return new Promise((resolve, reject) => {
        const machineType = type.indexOf('天鸽') !== -1 ? '天鸽' : '天鹅';
        const reqFn = machineType === '天鸽' ? getColumbaAccessoryByRepairEquipmentId : getSwanAccessoryByRepairEquipmentId;

        const standardList = standardConfigOptions()[machineType];
        const optionalList = optionalOptions()[machineType];

        const findList = [];

        const findItem = (key) => {
            const standard = standardList.find((item) => item.searchVal === key);
            const optional = optionalList.find((item) => item.searchVal === key);
            return standard || optional
        }

        reqFn({
            repairEquipmentId: id
        }).then((res) => {
            if (res.code === 200 && res.message === '成功') {
                Object.keys(res.data).forEach((key) => {
                    if (key === 'id' || key === 'repairEquipmentId') return
                    const item = findItem(key);
                    item.val = res.data[key];
                    findList.push(item);
                    resolve({
                        findList: findList, id: res.data.id
                    });
                });
            }
        }).catch((err) => {
            reject(err)
        });
    })
};
